<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <tabela :loading="loading" :items="items" @rechargeTable="getAll()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TratativasArquivosService from '@/services/TratativasArquivosService';
  import dayjs from 'dayjs';

  export default {
    components: {
      Tabela: () => import('@/components/arquivosDados/TabelaArquivosTratados.vue')
    },

    data: () => ({
      items: [],
      loading: false
    }),

    mounted() {
      this.getAll();
    },

    methods: {
      getAll() {
        this.loading = true;

        TratativasArquivosService.getAllExecucoes()
          .then(({ data }) => {
            this.items = [];

            data.data.forEach((element) => {
              this.items.push({
                id: element.id,
                tratativa: element.tratativa.nome,
                arquivo_original: element.arquivo_original.arquivo,
                arquivo_tratado: element.arquivo_tratado?.arquivo || '-',
                arquivo_tratado_id: element.arquivo_tratado?.id || null,
                ano: element.arquivo_original.ano,
                mes: element.arquivo_original.mes,
                status: element.status,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                created: element.created,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-'
              });
            });
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro buscar os Arquivos.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
